import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FournisseurService } from '../../../../../../../services/Fournisseur/fournisseur.service';
import {
    getReferenceFromAncestorRoute,
    resolveFournisseurDbIdFromRouteParam
} from '../fournisseur-doc-route.util';

@Component({
    selector: 'app-fr-doc-facture',
    templateUrl: './fr-doc-facture.component.html',
    styleUrls: ['./fr-doc-facture.component.scss']
})
export class FrDocFactureComponent implements OnInit {
    readonly docType = 'facture-fournisseur' as const;
    fournisseurId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private fournisseurService: FournisseurService
    ) {}

    ngOnInit(): void {
        const ref = getReferenceFromAncestorRoute(this.route);
        resolveFournisseurDbIdFromRouteParam(ref, this.fournisseurService).subscribe(id => {
            this.fournisseurId = id;
        });
    }
}
